import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthService } from 'src/app/services/auth/auth.service';
import { BrandsService } from 'src/app/services/brands/brands.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { DataTable } from '@pascalhonegger/ng-datatable';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { GlobalService } from 'src/app/services/global-service/global-service.service';
import { ModelsService } from 'src/app/services/models/models.service';
import { TranslateService } from '@ngx-translate/core';
import { VehiclesService } from 'src/app/services/vehicles/vehicles.service';

@Component({
  selector: 'app-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrls: ['./vehicles-list.component.scss']
})

export class VehiclesListComponent implements OnInit {
  @ViewChild('dataTable') dataTable: DataTable;

  electricVehicle: any = {};
  modelsListOptions: any;
  selectedBrand: any;
  selectedModel: any;
  brands: [];
  models: [];
  loadingSpinner = false;
  loadingSpinnerModal = false;
  isSubmitted = false;
  isLicensePlateUsed = false;
  electricVehicles: any = {};
  vehicleSelected: any;
  licensePlateControl = new UntypedFormControl('', [Validators.required]);
  usernameControl = new UntypedFormControl('', [Validators.required]);
  responsive: any;
  noDataSearch = false;
  body = [];
  searchText: string;
  vehicles = [];
  pageSize = 5;
  currentSortColumn: string;
  currentSortOrder = 'asc';
  excel: any = [];
  tableDataExcel: any = [];
  enterprise: any;
  employees: any;
  getFiltersForm: UntypedFormGroup;
  searchTextBrand: any;
  searchTextModel: any;
  searchTextLicense: any;
  searchTextUsername: any;
  vehiclesFilter = [];
  noDataFound = true;
  excelArray: {};
  displayEditModal: boolean;
  displayDeleteModal: boolean;

  constructor(
    private readonly constantService: ConstantService,
    private readonly translateService: TranslateService,
    private readonly vehiclesService: VehiclesService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly brandsService: BrandsService,
    private readonly modelsService: ModelsService,
    private readonly storageService: CustomStorageService,
    private readonly globalService: GlobalService,
    private readonly authService: AuthService,
    private readonly enterpriseService: EnterpriseService,
  ) { }

  /**
   * ngOnInit Function
   */
  ngOnInit() {
    this.enterprise = this.storageService.getEnterprise();
    this.loadingSpinner = true;
    this.initializeFilters();
    this.loadData();
    this.loadDataEmployee();
    this.getBrandsList();
  }

  initializeFilters() {
    this.getFiltersForm = this.formBuilder.group({
      searchTextBrand: this.searchTextBrand,
      searchTextModel: this.searchTextModel,
      searchTextLicense: this.searchTextLicense,
      searchTextUsername: this.searchTextUsername,
    });
  }

  /**
   * load Data Inside ngOnInit
   */
  loadData() {
    this.searchTextBrand = this.getFiltersForm.controls.searchTextBrand.setValue('');
    this.searchTextModel = this.getFiltersForm.controls.searchTextModel.setValue('');
    this.searchTextLicense = this.getFiltersForm.controls.searchTextLicense.setValue('');
    this.searchTextUsername = this.getFiltersForm.controls.searchTextUsername.setValue('');
    this.loadingSpinner = true;
    this.noDataFound = true;
    this.vehiclesService.getVehicles(this.enterprise.id).subscribe((data: any) => {
      this.loadingSpinner = false;
      if (data.data.length > 0) {
        this.noDataFound = false;
        this.vehicles = data.data.map(x => ({
          brand: x.model.brand.name ? x.model.brand.name : '--',
          model: x.model.name ? x.model.name : '--',
          modelId: x.model ? x.model._id : '--',
          brandId: x.model ? x.model.brand._id : '--',
          userObject: x.user ? x.user : '--',
          License: x.licensePlate ? x.licensePlate : '--',
          chargingLevel: x.model.chargingLevel ? x.model.chargingLevel : '--',
          icon: x.model.brand.icon ? x.model.brand.icon : '--',
          _id: x._id,
          user: x.user ? x.user : null,
          username: x.user ? x.user.username : '--',
        }));
        this.vehiclesFilter = this.vehicles;
        // data for excel
        this.saveDataExcel();
      }
    }, error => {
      this.loadingSpinner = false;
    });
  }

  /**
   * get list brand.
   */
  getBrandsList() {
    this.brandsService.getBrands().subscribe((res: any) => {
      this.loadingSpinnerModal = false;
      const brandsWithModels = res.data.filter(brand => brand.models.length > 0);
      this.brands = brandsWithModels.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      if (this.electricVehicles.model?.brand?._id) {
        this.electricVehicle.brand = this.electricVehicles.model.brand._id;
      }
      this.onChangeBrand();
    });
  }

  /**
   * get anonymous list
   */
  loadDataEmployee() {
    this.enterpriseService.getEmployees().subscribe((data: any) => {
      this.employees = data.users
        .filter((x) => (x.type === 'EnterpriseMember' || x.type === 'Member' || x.type === 'EnterpriseOfficer') &&
          (x.isAnonymous === false) && (x.isDeleted === false));
      const noneEmployee = {
        username: this.translateService.instant('no_owner_selected'),
        id: '',
      };
      this.employees.push(noneEmployee);
    });
  }

  /**
   * Save the data in the excel array
   */
  saveDataExcel() {
    this.tableDataExcel = this.vehicles.map(x => ({
      Brand: x.brand,
      Model: x.model,
      LicensePlate: x.License,
      Charging_level: x.chargingLevel,
      USER: x.user.username,
    }));
    console.log('VehiclesListComponent ~ saveDataExcel ~ this.vehicles:', this.vehicles);
    this.excel = this.constantService.translateKeys(this.tableDataExcel);
    console.log('VehiclesListComponent ~ saveDataExcel ~ this.tableDataExcel:', this.tableDataExcel);
  }

  paginateChange(event) {
    this.dataTable.setPage(1, this.dataTable.rowsOnPage);
  }

  /**
   * Multi search function on vehicle table
   */
  onFilterChange() {
    this.searchTextBrand = this.getFiltersForm.controls.searchTextBrand.value;
    this.searchTextLicense = this.getFiltersForm.controls.searchTextLicense.value;
    this.searchTextUsername = this.getFiltersForm.controls.searchTextUsername.value;

    this.vehicles = this.vehiclesFilter.filter(vehicle => {
      let isPassed = true;
      if (this.searchTextBrand && this.searchTextBrand !== '') {
        this.searchTextBrand = this.searchTextBrand.name ? this.searchTextBrand.name.trim().toLowerCase() : this.searchTextBrand.trim().toLowerCase();
        isPassed = isPassed && vehicle.brand.trim().toLowerCase().indexOf(this.searchTextBrand) > -1;
      }

      if (this.searchTextModel && this.searchTextModel !== '') {
        this.searchTextModel = this.searchTextModel.name ? this.searchTextModel.name.trim().toLowerCase() : this.searchTextModel.trim().toLowerCase();
        isPassed = isPassed && vehicle.model.trim().toLowerCase().indexOf(this.searchTextModel) > -1;
      }

      if (this.searchTextLicense && this.searchTextLicense !== '') {
        vehicle.License = vehicle.License.toString().trim().toLowerCase();
        this.searchTextLicense = this.searchTextLicense.trim().toLowerCase();
        isPassed = isPassed && vehicle.License.indexOf(this.searchTextLicense) > -1;
      }

      if (this.searchTextUsername && this.searchTextUsername !== '') {
        vehicle.user = vehicle.user.toString().trim().toLowerCase();
        this.searchTextUsername = this.searchTextUsername.trim().toLowerCase();
        isPassed = isPassed && vehicle.user.indexOf(this.searchTextUsername) > -1;
      }

      return isPassed;
    });
    this.saveDataExcel();
    this.vehicles.length > 0 ? this.noDataSearch = false : this.noDataSearch = true;
  }

  /**
   * Function is called to open modal contact.
   */
  openDialog(data, action) {
    this.loadingSpinnerModal = true;
    if (action === 'edit') {
      this.displayEditModal = true;
    } else if (action === 'delete') {
      this.displayDeleteModal = true;
    }
    this.vehiclesService.getVehicleById(data._id).subscribe(data => {
      this.getBrandsList();
      this.electricVehicles = data;
      this.electricVehicle.id = this.electricVehicles._id;
      this.electricVehicle.licensePlate = this.electricVehicles.licensePlate;
      if (this.electricVehicles.user) {
        this.electricVehicle.user = this.electricVehicles.user.id;
      } else {
        this.electricVehicle.user = '';
      }
    });

  }

  /**
   * edit vehicle based on id given
   */
  editVehicle() {
    this.isSubmitted = true;
    if (this.electricVehicle.user === undefined || this.electricVehicle.user === 'null' || this.electricVehicle.user === '') {
      this.electricVehicle.user = null;
    }
    this.vehiclesService.updateVehicle(this.electricVehicle, this.electricVehicle.id).subscribe(async (res) => {
      this.isLicensePlateUsed = false;
      this.constantService.showSuccessToast('toast.vehicle_edit_success');
      this.loadData();
    }, error => {
      switch (error.status) {
        case 401:
          this.authService.logout();
          break;
        case 409:
          if (error.error.message === 'License plate used!') {
            this.isLicensePlateUsed = true;
          }
          break;
        default:
          this.constantService.showErrorToast('toast.error_server');
          break;
      }
    }
    );
  }

  /**
   * Delete vehicle based on id and index given
   */
  deleteVehicle() {
    this.loadingSpinner = true;
    const user = this.vehiclesService.deleteVehicle(this.electricVehicle.id).subscribe(res => {
      this.loadData();
      this.constantService.showSuccessToast('toast.vehicle_delete_success');
    }, error => {
      this.loadingSpinner = false;
      switch (error.status) {
        case 401:
          this.authService.logout();
          break;
        default:
          this.constantService.showErrorToast('toast.error_server');
          break;
      }
    });
  }

  handleLicensePlate(event) {
    this.isLicensePlateUsed = false;
  }

  /**
   *  Download excel
   */
  exportAsXLSX(): void {
    this.constantService.exportAsXLSX(this.excel, 'pages_titles.vehicles.list');
  }

  /**
   * change brand in select.
   */
  onChangeBrand(event?) {
    let brand;
    if (event) {
      brand = event.value._id;
      this.searchTextModel = '';
    } else {
      brand = this.electricVehicle.brand;
    }
    if (brand) {
      this.models = [];
      this.loadingSpinnerModal = true;
      this.modelsService.getModelsByBrand(brand).subscribe((res: any) => {
        this.loadingSpinnerModal = false;
        this.models = res.models;
        this.models = this.models.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
        if (this.electricVehicles.model?._id) {
          this.electricVehicle.model = this.electricVehicles.model._id;
        }
      });
    }
  }

  /**
   * change brand in select.
   */
  onChangeModel(event?) {
    this.searchTextModel = event.value.name;
  }
  /**
   * get full name of user
   */
  getFullName(user) {
    return this.globalService.getFullName(user.username, user.firstName, user.lastName);
  }

  navigateToUsersList(username) {
    this.constantService.navigateToUsers('/list', username);
  }
}
